<template>
    <div class="search">
        <div class="search__header">
            <span>Cambiar país:</span>
            <button @click="$store.commit('modals/modalHandler', { name: 'modalCountry', boolean: true })" type="button">
                {{ country.name }}
            </button>
        </div>
        <form @submit.prevent="search" autocomplete="off" class="search__form">
            <div class="search__location">
                <input @input="suggestionsRequest" @keyup="suggestionKeyup" placeholder="Ingrese ciudad, localidad o barrio." type="text" v-model="request.term" v-autofocus="focusInput" autocomplete="chrome-off" v-on:change="changeInput" />
                <ul v-show="suggestions.length > 0 && suggestion">
                    <li
                        :class="{ active: currentSuggestion == inx }"
                        :key="inx"
                        @click="suggestionSelected(suggestion)"
                        @mouseover="suggestionMouseover(inx)"
                        v-for="(suggestion, inx) in suggestions"
                    >
                        {{ suggestion.description }}
                    </li>
                </ul>
            </div>
            <v-select :options="operations" v-model="request.operation" />
            <v-select :options="types" v-model="request.type" />
            <button type="submit">Buscar</button>
        </form>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

import accents from '../helpers/accents'

import { suggestions } from '@/services/ApiMapaprop'

export default {
    data() {
        return {
            suggestion: false,
            currentSuggestion: 0,
            request: {
                operation: '1',
                type: '1',
                term: ''
            },
            selected: {},
            suggestions: [],
            focusInput: true
        }
    },
    computed: {
        ...mapGetters({
            country: 'countries/country',
            operations: 'requests/operations',
            types: 'requests/types'
        })
    },
    methods: {
        async suggestionsRequest() {
            if (this.request.term.length > 3) {
                const response = await suggestions({
                    country: this.country.code,
                    limit: 8,
                    term: accents(this.request.term)
                })

                this.selected = {}

                if (response.data.length > 0) {
                    this.suggestions = response.data
                    this.suggestion = true
                } else {
                    this.suggestions = []
                }
            }
        },
        suggestionMouseover(inx) {
            this.currentSuggestion = inx
            this.selected = this.suggestions[this.currentSuggestion]
        },
        suggestionKeyup(e) {
            if (e.key == 'ArrowUp' && this.suggestions.length > 0 && this.currentSuggestion > 0) {
                this.currentSuggestion--
                this.request.term = this.suggestions[this.currentSuggestion].description
                this.selected = this.suggestions[this.currentSuggestion]
            } else if (e.key == 'ArrowDown' && this.suggestions.length > 0 && this.currentSuggestion < this.suggestions.length - 1) {
                this.currentSuggestion++
                this.request.term = this.suggestions[this.currentSuggestion].description
                this.selected = this.suggestions[this.currentSuggestion]
            } else if (e.key == 'Enter' && this.suggestions.length > 0) {
                this.request.term = this.suggestions[this.currentSuggestion].description
                this.selected = this.suggestions[this.currentSuggestion]
            }
        },
        suggestionSelected(suggestion) {
            this.request.term = suggestion.description
            this.selected = suggestion
            this.suggestions = []
        },

        search() {
            const codeCountry = this.country.code.toLowerCase()

            let operationValue = ''

            for (const operation of this.operations) {
                if (operation.key == this.request.operation) {
                    operationValue = operation.value
                }
            }

            let typeValue = ''

            for (const type of this.types) {
                if (type.key == this.request.type) {
                    typeValue = type.value
                }
            }
            if (Object.keys(this.selected).length !== 0) {
                const url = `/${codeCountry}/buscar/operacion-${accents(operationValue, '-')}_${this.request.operation}/tipo-${accents(
                    typeValue,
                    '-'
                )}_${this.request.type}/zona-${this.selected.seoUrl}_${this.selected.localCode}`

                this.$store.dispatch('local/historiesSearchAction', {
                    country: codeCountry,
                    name: this.selected.description,
                    url: url
                })

                this.$router.push(url)
            }
        },
        clickSuggestions(e) {
            const suggestions = document.querySelector('.search__location')

            if (suggestions.contains(e.target)) {
                this.suggestion = true
            } else {
                this.suggestion = false
            }
        },
        changeInput(e) {
            this.focusInput = !e.target.value.length
        }
    },
    created() {
        document.addEventListener('click', this.clickSuggestions)
    },
    destroyed() {
        document.removeEventListener('click', this.clickSuggestions)
    }
}
</script>

<style lang="scss">
.search {
    width: 100%;
    max-width: 1000px;
    margin-left: auto;
    margin-right: auto;
    padding: 1rem;
    display: grid;
    grid-gap: 1rem;
    grid-template-columns: 1fr;
    border-radius: 4px;
    background-color: rgba(#ffffff, 0.6);
    &__header {
        display: flex;
        align-items: center;
        span {
            margin-right: 0.5rem;
            display: inline-block;
            font-weight: bold;
        }
        button {
            height: 30px;
            width: auto;
            padding-left: 0.5rem;
            padding-right: 0.5rem;
            font-size: 0.8rem;
            border-radius: 4px;
            color: #ffffff;
            background-color: rgba(#000000, 0.6);
        }
    }
    &__form {
        display: grid;
        grid-gap: 2px;
        grid-template-columns: 400px auto auto 100px;
        input {
            padding-left: 0.5rem;
            padding-right: 0.5rem;
            border-radius: 4px 0 0 4px;
        }
        button {
            color: #ffffff;
            border-radius: 0 4px 4px 0;
            background-color: #c9d700;
        }
    }
    &__location {
        position: relative;
        ul {
            user-select: none;
            position: absolute;
            z-index: 3;
            top: calc(100% + 2px);
            left: 0;
            max-height: 300px;
            width: 100%;
            border-radius: 0 0 4px 4px;
            overflow: auto;
            background-color: #ffffff;
            box-shadow: 0 0 4px 0 rgba(#000000, 0.2);
            li {
                cursor: pointer;
                padding: 0.4rem 0.5rem;
                display: flex;
                align-items: center;
                border-bottom: 1px solid #f3f3f3;
                &.active {
                    background-color: #f3f3f3;
                }
            }
        }
    }
    @media (max-width: 992px) {
        &__form {
            grid-gap: 0.5rem;
            grid-template-columns: 1fr;
            .select {
                &:nth-of-type(1) {
                    border-radius: 4px;
                }
                &:nth-of-type(2) {
                    border-radius: 4px;
                }
            }
            input {
                border-radius: 4px;
            }
            button {
                border-radius: 4px;
            }
        }
        &__location {
            ul {
                border-radius: 4px;
            }
        }
    }
}
</style>
